"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.intercept = void 0;
exports.intercept = (interceptArg, fetch) => {
    return (...fetchArgs) => {
        let promise = Promise.resolve(fetchArgs);
        if (interceptArg.request) {
            promise = promise.then((args) => interceptArg.request(...args));
        }
        let result = promise.then((args) => fetch(...args));
        if (interceptArg.response || interceptArg.error) {
            result = result.then(interceptArg.response, interceptArg.error);
        }
        return result;
    };
};
